export default __webpack_public_path__ + "static/open-gmail-sidebar-447364600cf977f5b074f01fdf90938c.mp4";